import { createAsyncThunk } from '@reduxjs/toolkit';
import { addMessage } from '../Slices/MessageSlice.jsx';
import Cookies from 'js-cookie';
import { setUnavailableProducts } from '../Slices/CartSlice.jsx';

export const getOutOfStockProductsText = (cart, translations) => {
  let oosProducts = cart?.lineItems?.filter((x) => !x.isInStock);
  let oosText = translations.shipping.shippingLabels.productsOutOfStock;
  oosProducts.forEach((product) => {
    oosText += `<li class="ms-3">${product.webtitle1}</li>`;
  });

  return oosText;
};

export const handlePfasProducts = createAsyncThunk(
  'handlePfasProducts',
  async (_, { dispatch, getState, rejectWithValue }) => {
    let state = getState();
    let shippingFields = state.Shipping.shipping;
    let country = state.Cart.country;
    let stateValue = shippingFields.state.value ? shippingFields.state.value : 'NA';

    let activePfasMarkets = window._THULEDATA._Checkout.activePfasMarkets;
    let activePfasStates = window._THULEDATA._Checkout.activePfasStates;

    const shouldHandlePfasProducts = activePfasMarkets.includes(country) && activePfasStates.includes(stateValue);
    if (!shouldHandlePfasProducts) {
      return { handled: false }; // Return a valid response when we don't need to handle PFAS
    }

    let bodyPfas = JSON.stringify({
      State: stateValue,
      CartId: Cookies.get('cartId'),
      Locale: window._THULEDATA.SitecoreLanguage,
    });

    let options = {
      method: 'POST',
      body: bodyPfas,
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    };

    try {
      let result = await fetch('/api/sitecore/cart/HandlePfasProductsInCart', options).then((data) => data.json());
      if (!result) {
        return { ...state.Cart, handled: true }; // Return the current state if the response is empty to avoid stopping the checkout process.
      }

      let unavailableProducts = [];
      result?.lineItems?.forEach((line) => {
        if (line.missingPfasReplacement || !line.isInStock) {
          let pfasErrorText =
            window._THULEDATA._Checkout.translations.pfasErrorMessage + ' ' + line.webtitle1 + ' - ' + line.webtitle2;
          const msgBody = {
            id: 'unavailableProducts_' + line.id,
            content: pfasErrorText,
            type: 'error',
          };
          dispatch(addMessage(msgBody));
          unavailableProducts.push(line.id);
        }
      });

      if (unavailableProducts?.length > 0) {
        dispatch(setUnavailableProducts(unavailableProducts));
        window.scrollTo(0, 0);
      }

      return { ...result, handled: true };
    } catch (error) {
      return rejectWithValue('Error handling PFAS products: ' + error.message);
    }
  }
);
